import { Info } from "@mui/icons-material";
import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import { TrainingView } from "@my-helpers/common";

interface TrainingBasicInfoProps {
    training?: TrainingView;
}

const TrainingBasicInfo: React.FC<TrainingBasicInfoProps> = ({ training }) => {

    const formatDate = (dateString: string): string => {
        return new Date(dateString).toLocaleString();
    };
    
    const getStatusColor = (status: string): "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" => {
        switch (status) {
            case 'loaded': return 'success';
            case 'loading': return 'info';
            case 'failed': return 'error';
            case 'available': return 'primary';
            default: return 'default';
        }
    };
    
    return (
        <Card sx={{
            flex: 1,
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <CardContent sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', fontSize: '1.1rem' }}>
                    <Info sx={{ mr: 1, color: 'primary.main', fontSize: '1.2rem' }} />
                    Basic Information
                </Typography>

                {/* Status and Version */}
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary', mb: 1 }}>
                        Status
                    </Typography>
                    <Chip
                        label={training?.status || ''}
                        color={getStatusColor(training?.status || '')}
                        size="small"
                        sx={{ mb: 1 }}
                    />
                </Box>

                <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary', mb: 1 }}>
                        Version
                    </Typography>
                    <Chip
                        label={`${training?.version || ''}`}
                        variant="outlined"
                        size="small"
                        sx={{ mb: 1 }}
                    />
                </Box>

                {/* Other Basic Info */}
                <Box sx={{ display: 'grid', gap: 2 }}>
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary' }}>
                            Model Size
                        </Typography>
                        <Typography variant="body2">
                            {training?.size || ''}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary' }}>
                            Updated
                        </Typography>
                        <Typography variant="body2">
                            {formatDate(training?.updated_at || '')}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default TrainingBasicInfo;